import { render, staticRenderFns } from "./AssessmentSubjectCompare.vue?vue&type=template&id=30d35d92&"
import script from "./AssessmentSubjectCompare.vue?vue&type=script&lang=js&"
export * from "./AssessmentSubjectCompare.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentSubjectCompare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports